import ColumnUtils from '@/utils/ColumnUtils'
import DateUtils from '@/utils/dateUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import {
  getJobList4External, queryJobPageable2ClosingAccountHandler, exportExcel4CarryForward
} from '@/api/clearing/financeManage'
import { getUserDepartmentGroup, getUserDepartmentTeamNew } from '@/api/user'

import { cacheName, cache } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'

import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { Assert } from '@/utils/validate'
import lodash from 'lodash'

import StrUtils from '@/utils/StrUtils'
import { Once } from '@/utils/commonUtil'
import { formatNumberToThousands } from '@/utils'
import * as LayersUtil from '@/class/cargo/model/utils/LayersUtil'
import { exportExcel } from '@/utils/tableDataExportUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import AbstractClosingAccount from '@/views/cargo/v0/Clearing/components/ClosingAccount/AbstractClosingAccount'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default class ClosingAccountHp extends AbstractClosingAccount {
  constructor(view) {
    super(view)
    this._fieldSuffix = '_wrapper'
    this.once = new Once(this)
  }

  updateResultProvisioned() {
    // this.doSearch()
    this.doSearchWithProfitAndList()
    this.$logger.log(' FinanceManageHP updateResultProvisioned')
  }

  async updateBusinessDateClickHandler() {
    await getGridSelectedIds(this._view.gridOptions, 'uuid', this.$t('Message.PleaseSelectTheBusiness'))
    this.cABtnGroupView.showBusinessDateDialog = true
  }

  async updateBusinessDateConfirmCB(businessDate) {
    const jobKeys = await getGridSelectedIds(this._view.gridOptions, 'uuid', this.$t('Message.PleaseSelectTheBusiness'))
    const loading = getLoading()
    Job.updateBusinessDate(jobKeys, businessDate).then(res => {
      this.cABtnGroupView.showBusinessDateDialog = false
      this.updateResultProvisioned()
      this.$message.success(this.$t('Message.BusinessDateModifiedSuccessfully'))
    }).catch(res => {
      // todo
    }).finally(() => { loading.close() })
  }

  /**
   * 查看
   * @param needChecked
   * @param detailData
   * @param gridOptions
   * @param treeDataArr
   * @param fromView
   * @returns {Promise<void>}
   * @private
   */
  async showDetailView(needChecked, detailData, gridOptions, treeDataArr, fromView = 'manageList') {
    if (needChecked) {
      const chooseRows = getGridSelected(gridOptions)
      await Assert.isTrue(chooseRows.length === 1, this.$t('common.tips.hasOneOnly'), 'warning')
      detailData = { ...chooseRows[0] }
    }
    this._view.showDetail = true
    this._view.detailViewSource = fromView
    this.$nextTick(() => {
      this.$refs.closingAccountDetail.showDetail({ ...detailData }, lodash.cloneDeep(treeDataArr))
      if (this._view.routeJobNo) {
        this.$refs.closingAccountDetail.activeTabName = 'tabCharges'
        this._view.routeJobNo = null
      }
    })
  }

  // 批量审核
  async batchAuditClickHandler() {
    // await cache.load(cacheName.CONFIG)
    const chooseRows = getGridSelected(this._view.gridOptions)
    await Assert.isTrue(chooseRows.length > 0, this.$t('Message.SelectJob'), 'warning')
    await cache.load(cacheName.CONFIG)
    this.cABtnGroupView.editApprovalDate = Number(cache.config.get('isAllowEditApprovalDate')) === 1
    this.cABtnGroupView.checkDialog.isEditable = true
    this.cABtnGroupView.showCheckDialog = true
  }
  showFinanceBtnGroupViewCall() {
    return true
  }

  async batchAuditConfirmCB({ accountDate, poNo }) {
    const jobKeys = await getGridSelectedIds(this._view.gridOptions, 'uuid')
    const chooseRows = getGridSelected(this._view.gridOptions)
    let invoiceDateSql = ''
    for (const job of chooseRows) {
      invoiceDateSql = job.invoiceDateSql
    }
    await super.batchAuditConfirmCB(jobKeys, accountDate, poNo, invoiceDateSql)
  }

  async batchAuditConfirmSuccessCB() {
    this.$message.success(this.$t('SeaExport.BatchAuditSuccess'))
  }

  async batchAuditConfirmFailCB() {
    this.$message.success(this.$t('Message.BatchApprovalFailed'))
  }

  // 核对审核日期
  async checkAccountDate(accountDate) {
    let check = false
    const chooseRows = getGridSelected(this._view.gridOptions)
    for (const job of chooseRows) {
      if (new Date(job.businessDate) > accountDate) {
        check = true
        break
      }
    }
    await this.$confirm(check ? this.$t('Message.TheApprovalDateIsEarlierThanTheBusinessDate') : this.$t('Message.AreYouSureToReviewTheseLists'), this.$t('common.tips.prompt'), { type: 'warning' })
  }

  updateDefaultMenuState(state) {
    // todo
    this.refresh()
  }

  refresh() {
    // this.doSearch()
    this.doSearchWithProfitAndList()
  }

  // 改单
  async batchCheckChangeConfirmCB(accountDate) {
    await super.batchCheckChangeConfirmCB(this.cABtnGroupView.hp.selectionUuids, accountDate)
  }

  // 批量改单
  async batchCheckChangeClickHandler() {
    const list = getGridSelected(this._view.gridOptions)
    await Assert.isTrue(list.length > 0, this.$t('Message.SelectJob'), 'warning')
    for (const job of list) {
      if (Number(job.changeState) !== Number(SystemConstants.CHANGE_COMMIT.code)) {
        this.$message.warning(this.$t('Message.NoInTheSelectedData', [SystemConstants.CHANGE_COMMIT.chineseName]))
        return
      }
    }
    this.cABtnGroupView.showChangeDialog = true
  }

  // 导出全部
  async exportExcelAllClickHandler(type = '') {
    this._view.searchExportExcel = true
    this._view.search2({ simpleTriggerMode: this._view.simpleTriggerMode, conditions: type === 'detail' ? null : this._view.beforeConditions })
  }

  resultHandler(wrapper) {
    super.resultHandler(wrapper)
  }

  toQueryList(roleMap = null) {
    let loading = null
    const { snapshotConditions: conditions, requires, pageNum, pageSize } = this._view.searchConditions
    const requestBody = {
      conditions,
      requires,
      roleMap,
      pageNum,
      pageSize
    }
    // 通过业务编号点击跳转到财务审核的界面时，查询条件不能追加分公司
    if (!this.view.routeJobNo) {
      requestBody.branchId = this.$store.getters.currentOfficeId
    }
    this.$logger.log('requestBody', requestBody)

    if (this._view.searchExportExcel) {
      loading = getLoading(null, { fullscreen: false })
      // 导出全部，需要 实时获取 用户的 搜索条件
      exportExcel4CarryForward({ ...requestBody }).then(async res => {
        console.time('列数据转换渲染:')
        const { columnApi } = this._view.gridOptions
        // 获取显示列
        const allDisplayedColumns = columnApi.getAllDisplayedColumns()
        await exportExcel(this.$t('CargoMsg.Cargo_CarryForwardList'), res.data.results.list, allDisplayedColumns)
      }).finally(() => {
        loading.close()
      })
    } else {
      let apiRequest = queryJobPageable2ClosingAccountHandler
      loading = getLoading(null, { fullscreen: false })
      if (this._view.routeJobNo) {
        apiRequest = getJobList4External
      } else {
        super.clearBottomTotalData()
      }
      apiRequest(requestBody).then(res => {
        // console.log('this._view.rowData', this._view.rowData)
        this._view.rowData = res.data.results.list
        this.otherDataHandler()
        this.resultHandler(res.data)
        this._view.searchConditions.total = Number(res.data.results.total)
        this._view.searchConditions.pageCount = res.data.results.pages
      }).finally(() => {
        if (this._view.routeJobNo) {
          // console.log('financeManage', this._view.gridOptions.api.getFirstDisplayedRow())
          const renderedNode = this._view.gridOptions.api.getRenderedNodes()
          if (renderedNode.length !== 0) {
            console.log(this._view.gridOptions.api.getRenderedNodes())
            renderedNode.find(node => node.data.jobNo === this._view.routeJobNo).setSelected(true)
            this.showDetailView(true, null, this._view.gridOptions, this._view.rowData)
          }
        }
        loading.close()
      })
    }
  }
  otherDataHandler() {
    if (this._view.rowData) {
      for (const d of this._view.rowData) {
        d.loadingPortCodeString = portLabelFunc(d, d.loadingPortCode)
        d.airDestinationPortCodeString = airDestinationPortFunction(d, d.airDestinationPortCode)
        d.dischargingPortCodeString = portLabelFunc(d, d.dischargingPortCode)
        d.opStr = CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', d.op, 'auto_op')
        d.createdByString = CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', d.createdBy, 'auto_op')
        d.carrierIdString = carrierLabelFunc(d, d.carrierId)
      }
    }
  }
  async toQueryListWithProfitAndList(roleMap = null, queryMasterDb = false) {
    return Promise.all([this.toQueryList(roleMap)])
  }
  async doSearchWithProfitAndList() {
    // 根据配置同步 受控权限
    await cache.load(cacheName.CONFIG)
    this._view.showControlledProfit = Number(cache.config.get('ShowControlledProfit')) === 1
    this._view.allJobByRole = this.$checkPermission(['role_ACPayAuth_allJob'])
    this._view.departmentJobByRole = this.$checkPermission(['role_ACPayAuth_departmentJob'])
    await this.doSearch()
  }

  async doSearch() {
    if (this._view.allJobByRole || !this._view.hasCheckRole) {
      const roleMap = {}
      const controlled = this.$checkPermission(['button_Charge_controlled'])
      const costControlled = this.$checkPermission(['button_Charge_costControlled'])
      const showControlledProfit = this._view.showControlledProfit
      roleMap['controlled'] = controlled
      roleMap['costControlled'] = costControlled
      roleMap['showControlledProfit'] = showControlledProfit
      this.toQueryList(roleMap)
    } else {
      if (this._view.departmentJobByRole) {
        // 财务审核-同组部门下的用户
        getUserDepartmentGroup({ category: 'role', shape: 'ACPayAuth', point: 'departmentJob' }).then(async res => {
          const departmentKeys = res && res.data ? Array.from(res.data, p => p.uuid) : []
          // 同组部门下的用户
          const resData = await getUserDepartmentTeamNew(departmentKeys, this.$store.getters.currentOfficeId).then(res => {
            return res.data
          })
          this.getUserDepartmentTeamHandler(resData)
        }).catch(() => {
          this.$message.warning(this.$t('Message.QueryFailed'))
        })
      } else {
        super.queryDataRole(false)
      }
    }
  }

  async beforeMount() {
    super.beforeMount()
    cache.load(cacheName.CONFIG).then(() => {
      this._view.showControlledProfit = Number(cache.config.get('ShowControlledProfit')) === 1
    })
  }

  created() {
    const cxt = this._view
    const currentThis = this
    this._view.documentManage.set('showTemplateDialog', function(uuid) {
      cxt.showTemplateDialog()
    })
    this._view.gridOptions = {
      suppressDoubleClickExpand: true,
      rowSelection: 'multiple',
      suppressCellSelection: true,
      treeData: true,
      groupDefaultExpanded: 2,
      getDataPath: data => {
        return data.path.split(',')
      },
      onSelectionChanged(event) {
        currentThis.once.excute(currentThis._view.filterChange)
      },
      onRowSelected(event) {
        console.log('onRowSelected', event)
      },
      autoGroupColumnDef: {
        headerName: this.$t('queryJob.businessNumber'),
        field: 'jobNo',
        colId: 'jobNo',
        width: 240,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true,
          checkbox: params => {
            return true
          },
          innerRenderer: params => {
            const methodPath = this._view.documentManage.getPath('showTemplateDialog')
            return `${params.value}<i class="el-icon-search" onclick="${methodPath}('${params.data.uuid}')" style="color:#46a6ff;cursor:pointer"/>`
          }
        }
      },
      onCellClicked: event => {
        this._view.selectedJob = event.data
        if (!this._view.selectedJob) {
          this._view.selectedJob = this.readSelectedRows()[0]
        }
      },
      onRowDoubleClicked: this._view.showDetailView4Manage,
      getRowStyle: (params) => {
        const row = params.data
        const colorType = Number(this.$store.state.settings.colorType) === 1
        if (colorType) {
          return JobUtils.financeColor(row)
        } else if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
          Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
          JobUtils.isBlockJob(row)) {
          return { 'background': LayersUtil.STATE_BLOCKED.colorValue }
        } else {
          const jobState = String(row.jobState) || ''
          for (const stateColor of LayersUtil.COLOR_STATES) {
            if (jobState === stateColor.colorKey) {
              return { 'background': stateColor.colorValue }
            }
          }
        }
        return {}
      }
    }
    this._view.columnDefs = [
      { headerName: this.$t('queryJob.closingAccountStatus'), colId: 'closingAccountStatus', field: 'closingAccountStatus', width: 180,
        valueFormatter: (params) => {
          const s = CommonState.getStateByCode(SystemConstants.CLOSINGACCOUNT_STATUS, params.value)
          if (s) {
            return this.$store.getters.language === 'zh' ? s.chineseName : s.englishName
          } else {
            return ''
          }
        }
      },
      { headerName: this.$t('queryJob.hasReceivable'), colId: 'hasReceivable', field: 'hasReceivable', width: 200,
        valueFormatter: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      },
      { headerName: this.$t('queryJob.totalIncomeExcludingTax'), colId: 'incomeExcludingTax', field: 'incomeExcludingTax', width: 200,
        valueFormatter: (params) => {
          if (params.value) {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } else {
            return '0.00'
          }
        }
      },
      { headerName: this.$t('queryJob.totalCostExcludingTax'), colId: 'costExcludingTax', field: 'costExcludingTax', width: 200,
        valueFormatter: (params) => {
          if (params.value) {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } else {
            return '0.00'
          }
        }
      },
      { headerName: this.$t('queryJob.profitExcludingTax'), colId: 'realProfitExcludingTax', field: 'realProfitExcludingTax', width: 200,
        valueFormatter: (params) => {
          if (params.value) {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } else {
            return '0.00'
          }
        }
      },
      { headerName: this.$t('queryJob.closingAccountRevenue'), colId: 'closingAccountRevenue', field: 'closingAccountRevenue', width: 200,
        valueFormatter: (params) => {
          if (params.value) {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } else {
            return '0.00'
          }
        }
      },
      { headerName: this.$t('queryJob.closingAccountCost'), colId: 'closingAccountCost', field: 'closingAccountCost', width: 200,
        valueFormatter: (params) => {
          if (params.value) {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } else {
            return '0.00'
          }
        }
      },
      { headerName: this.$t('queryJob.invoiceCost'), colId: 'invoiceCost', field: 'invoiceCost', width: 200,
        valueFormatter: (params) => {
          if (params.value) {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } else {
            return '0.00'
          }
        }
      },
      { headerName: this.$t('queryJob.totalIncomeClosingAccount'), colId: 'incomeClosingAccount', field: 'incomeClosingAccount', width: 200,
        valueFormatter: (params) => {
          if (params.value) {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } else {
            return '0.00'
          }
        }
      },
      { headerName: this.$t('queryJob.totalCostClosingAccount'), colId: 'costClosingAccount', field: 'costClosingAccount', width: 200,
        valueFormatter: (params) => {
          if (params.value) {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } else {
            return '0.00'
          }
        }
      },
      { headerName: this.$t('queryJob.profitClosingAccount'), colId: 'realProfitClosingAccount', field: 'realProfitClosingAccount', width: 200,
        valueFormatter: (params) => {
          if (params.value) {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } else {
            return '0.00'
          }
        }
      },
      { headerName: this.$t('queryJob.refundCommission'), colId: 'refundCommission', field: 'refundCommission', width: 200,
        valueFormatter: (params) => {
          if (params.value) {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          } else {
            return '0.00'
          }
        }
      },
      { headerName: this.$t('queryJob.businessType'), colId: 'lob', field: 'lob', width: 180,
        valueFormatter: (params) => {
          return ColumnUtils.jobBussStateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('queryJob.mblNo'), colId: 'mbl', field: 'mbl', width: 180 },
      { headerName: this.$t('queryJob.separateNumber'), colId: 'hblNb3', field: 'hblNb3', width: 180 },
      {
        headerName: this.$t('queryJob.customer'),
        colId: 'customerId',
        field: 'customerId',
        width: 180,
        valueFormatter: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
        }
      },
      {
        headerName: this.$t('SeaExport.CustomerLevel'),
        colId: 'customerTypeId',
        field: 'customerTypeId',
        width: 180,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value, 'chineseName')
        }
      },
      { headerName: this.$t('SeaExport.ContractStatus'), colId: 'contractStatus', field: 'contractStatus', width: 180 },
      {
        headerName: this.$t('SeaExport.OverseaCustomerService'),
        colId: 'overseaOp',
        field: 'overseaOp',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('queryJob.carrier'),
        colId: 'carrierIdString',
        field: 'carrierIdString',
        width: 180
      },
      {
        headerName: this.$t('queryJob.vessel'), colId: 'vessel', field: 'vessel',
        width: 180
      },
      {
        headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
        colId: 'scNo',
        field: 'scNo',
        width: 180,
        hide: true
      },
      { headerName: this.$t('queryJob.voyageFlight'), colId: 'voyageFlight', field: 'voyageFlight', width: 180 },
      {
        headerName: this.$t('queryJob.portOfLoading'),
        colId: 'loadingPortCodeString',
        field: 'loadingPortCodeString',
        width: 180
      },
      {
        headerName: this.$t('queryJob.portOfDestination'),
        colId: 'airDestinationPortCodeString',
        field: 'airDestinationPortCodeString',
        width: 180
      },
      {
        headerName: this.$t('queryJob.placeOfDelivery'),
        colId: 'destinationPortCode',
        field: 'destinationPortCode',
        width: 180,
        valueFormatter: (params) => {
          return destinationPlaceFunction(params.data, params.value)
        },
        filter: false,
        filterParams: {}
      },
      {
        headerName: this.$t('queryJob.dischargingPortCode'),
        colId: 'dischargingPortCodeString',
        field: 'dischargingPortCodeString',
        width: 180
      },
      { headerName: this.$t('CargoMsg.Cargo_ETD'), colId: 'etd', field: 'etd', width: 120,
        valueFormatter: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_ETA'), colId: 'eta', field: 'eta', width: 120,
        cellRenderer: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_ATD'), colId: 'atd', field: 'atd', width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_ATA'), colId: 'ata', field: 'ata', width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('queryJob.businessDate'),
        colId: 'businessDate',
        field: 'businessDate',
        width: 180, valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        }
      },
      {
        headerName: this.$t('queryJob.bookingAgent'),
        colId: 'bookingAgent',
        field: 'bookingAgent',
        width: 180, valueFormatter: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1')
        }
      },
      {
        headerName: this.$t('queryJob.dateOfCreation'),
        colId: 'dateCreated',
        field: 'dateCreated',
        width: 180, valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        }
      },
      {
        headerName: this.$t('queryJob.dateOfProof'),
        hide: true,
        colId: 'voucherExportDate',
        field: 'voucherExportDate',
        width: 180,
        hidden: !this._view.showVoucherDate, valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        }
      },
      {
        headerName: this.$t('queryJob.businessReferenceNumber'),
        colId: 'customerRefNo',
        field: 'customerRefNo',
        width: 180
      },
      { headerName: this.$t('queryJob.itemNo'), colId: 'poNo', field: 'poNo', width: 180 },
      {
        headerName: this.$t('queryJob.customJobType'),
        hide: true,
        colId: 'customJobType',
        field: 'customJobType',
        width: 180, valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name')
        }
      },
      { headerName: this.$t('queryJob.operation'), colId: 'opStr', field: 'opStr', width: 180 },
      { headerName: this.$t('queryJob.sales'), colId: 'sales', field: 'sales', width: 180,
        valueFormatter: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
        }
      },
      { headerName: this.$t('queryJob.CustomerService'), colId: 'csr', field: 'csr', width: 180,
        valueFormatter: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_csr')
        }
      },
      { headerName: this.$t('queryJob.Documents'), colId: 'dc', field: 'dc', width: 180,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      },
      {
        headerName: this.$t('queryJob.solicitationType'),
        colId: 'cargoSource',
        field: 'cargoSource',
        width: 180, valueFormatter: (params) => {
          return ColumnUtils.cargoSourceLabelFunction(params.value)
        }
      },
      {
        headerName: this.$t('queryJob.accrued'),
        hide: true,
        colId: 'provisioned',
        field: 'provisioned',
        width: 180, valueFormatter: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      },
      { headerName: this.$t('queryJob.status'), colId: 'jobState', field: 'jobState', width: 180, valueFormatter: (params) => {
        return ColumnUtils.getJobStateForBlock(params.data)
      },
      filterParams: {},
      filterValueGetter: (params) => {
        return ColumnUtils.getJobStateForBlock(params.data)
      } },
      {
        headerName: this.$t('queryJob.actualChargedWeight'),
        colId: 'chargeWeight',
        field: 'chargeWeight',
        width: 180, valueFormatter: (params) => {
          return Number(ColumnUtils.formatNumber(params.value, 3)).toFixed(3)
        }
      },
      {
        headerName: this.$t('queryJob.containerNo'),
        hide: true,
        colId: 'containerNos',
        field: 'containerNos',
        width: 180, valueFormatter: (params) => {
          return ColumnUtils.getJoinContainerNo(params.value)
        }
      },
      {
        headerName: this.$t('queryJob.profit'),
        colId: 'realProfit',
        field: 'realProfit',
        width: 180, valueFormatter: (params) => {
          return ColumnUtils.realProfit2Func(params.value)
        }
      },
      { headerName: this.$t('queryJob.totalIncome'), colId: 'income', field: 'income', width: 180, valueFormatter: (params) => {
        return formatNumberToThousands(ColumnUtils.formatNumber(params.value, 2, true, true))
      } },
      { headerName: this.$t('queryJob.totalCost'), colId: 'cost', field: 'cost', width: 180, valueFormatter: (params) => {
        return formatNumberToThousands(ColumnUtils.formatNumber(params.value, 2, true, true))
      } },
      { headerName: this.$t('queryJob.payablesWriteOfStatus'), colId: 'due', field: 'due', width: 180 },
      {
        headerName: this.$t('queryJob.receivablesWriteOfStatus'),
        colId: 'receivable',
        field: 'receivable',
        width: 180
      },
      {
        headerName: this.$t('queryJob.accrualDate'),
        hide: true,
        colId: 'provisionedDate',
        field: 'provisionedDate',
        width: 180, valueFormatter: (params) => {
          return DateUtils.formatStandardDate(params.value)
        }
      },
      {
        headerName: this.$t('queryJob.creator'),
        colId: 'createdByString',
        field: 'createdByString',
        width: 180
      },
      {
        headerName: this.$t('queryJob.containerDescription'),
        colId: 'containerDesc',
        field: 'containerDesc',
        width: 180
      },
      {
        headerName: this.$t('queryJob.designationAgent'),
        colId: 'designationAgent',
        field: 'designationAgent',
        width: 180, valueFormatter: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3')
        }
      },
      {
        headerName: this.$t('queryJob.masterBLFreightTerm'),
        colId: 'paymentTermMBL',
        field: 'paymentTermMBL',
        width: 180, valueFormatter: (params) => {
          return ColumnUtils.paymentTermLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('queryJob.HBLFreightClause'),
        colId: 'paymentTermHBL',
        field: 'paymentTermHBL',
        width: 180, valueFormatter: (params) => {
          return ColumnUtils.paymentTermLabelFunc(params.value)
        }
      },
      // 贸易条款
      { headerName: this.$t('queryJob.IncoTerm'), colId: 'incoTerm', field: 'incoTerm', width: 180 },
      {
        headerName: this.$t('queryJob.FLCLType'),
        colId: 'containerLoadType',
        field: 'containerLoadType',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
        }
      },
      {
        headerName: this.$t('queryJob.OperateType'),
        colId: 'operateType',
        field: 'operateType',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.operateTypeLabelFunc(params.data, 'operateType')
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.operateTypeLabelFunc(params.data, 'operateType')
        }
      },
      {
        headerName: this.$t('queryJob.UserDefinedField1'),
        colId: 'userDefinedField1',
        field: 'userDefinedField1',
        hide: true,
        width: 180
      },
      {
        headerName: this.$t('queryJob.UserDefinedField2'),
        colId: 'userDefinedField2',
        field: 'userDefinedField2',
        hide: true,
        width: 180
      },
      {
        headerName: this.$t('queryJob.UserDefinedField3'),
        colId: 'userDefinedField3',
        field: 'userDefinedField3',
        hide: true,
        width: 180
      },
      {
        headerName: this.$t('queryJob.ManageAuditStatus'),
        colId: 'manageAuditStatus',
        field: 'manageAuditStatus',
        hide: true,
        width: 180, valueFormatter: (params) => {
          return ColumnUtils.manageAuditStatusLabelFunction(params.value)
        }
      }
    ]
  }

  // 优化列值
  optimizeColumnValue(params, column, columnVal, convertNumber = true) {
    // 进行labelFunction 处理
    if (column.cellRenderer && typeof column.cellRenderer !== 'string') {
      columnVal = column.cellRenderer(params)
    }
    // 箱号不需要去掉千分符
    if (column.field !== 'containerNo' && column.field !== 'containerNos' && columnVal && !StrUtils.isChinese(columnVal) && !StrUtils.isEnglish(columnVal) && convertNumber) {
      // 去掉千位分隔符
      let dataStr = columnVal.toString()
      dataStr = dataStr.replace(/,/g, '')
      const precision = dataStr.split('.')[1] ? dataStr.split('.')[1].length : 0
      if (!isNaN(Number(dataStr)) && precision) {
        columnVal = Number(dataStr)
      }
    }
    if (columnVal && typeof columnVal === 'string') {
      columnVal = StrUtils.replaceSpecialCharacter(columnVal)
    }
    return columnVal
  }

  // 导出excel
  async exportExcel4Grid(rows, columns, fileName) {
    const headers = []
    const excelRows = []
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i]
      const excelRow = []
      columns.forEach(column => {
        const { field, headerName } = column
        // const fieldHeader = `${field}_|_|_${headerName}`
        if (headerName || field) {
          if (i === 0) {
            headers.push(headerName)
          }
          // console.log('field', field)
          let columnVal = row.hasOwnProperty(field) ? row[field] : ''
          const params = { data: row, value: row[field] }
          columnVal = this.optimizeColumnValue(params, column, columnVal)
          excelRow.push(columnVal)
        }
      })
      excelRows.push(excelRow)
    }

    // console.log('excelRows', excelRows)

    await import('@/vendor/Export2Excel').then(excel => {
      excel.export_json_to_excel({
        header: headers,
        data: excelRows,
        filename: fileName
      })
    })
  }

  getExcelColumnFields() {
    const excelColumnDefs = [
      { field: 'jobNo', headerName: this.$t('queryJob.businessNumber'), width: 180 },
      { field: 'lob', headerName: this.$t('queryJob.businessType'), width: 180 },
      { field: 'mbl', headerName: this.$t('queryJob.mblNo'), width: 180 },
      { field: 'hblNb3', headerName: this.$t('queryJob.separateNumber'), width: 180 },
      { field: 'customerId', headerName: this.$t('queryJob.customer'), width: 180 },
      { field: 'carrierId', headerName: this.$t('queryJob.carrier'), width: 180 },
      { field: 'vessel', headerName: this.$t('queryJob.vessel'), width: 180 },
      // { field: 'scNo', headerName: 'scNo', width: 180 },
      { field: 'voyageFlight', headerName: this.$t('queryJob.voyageFlight'), width: 180 },
      { field: 'loadingPortCode', headerName: this.$t('queryJob.portOfLoading'), width: 180 },
      {
        field: 'airDestinationPortCode',
        headerName: this.$t('queryJob.portOfDestination'),
        width: 180
      },
      { field: 'destinationPortCode', headerName: this.$t('queryJob.placeOfDelivery'), width: 180 },
      {
        field: 'dischargingPortCode',
        headerName: this.$t('queryJob.dischargingPortCode'),
        width: 180
      },
      { field: 'etd', headerName: this.$t('CargoMsg.Cargo_ETD'), width: 180 },
      { field: 'eta', headerName: this.$t('CargoMsg.Cargo_ETA'), width: 180 },
      { field: 'atd', headerName: this.$t('CargoMsg.Cargo_ATD'), width: 180 },
      { field: 'ata', headerName: this.$t('CargoMsg.Cargo_ATA'), width: 180 },
      { field: 'businessDate', headerName: this.$t('queryJob.businessDate'), width: 180 },
      { field: 'bookingAgent', headerName: this.$t('queryJob.bookingAgent'), width: 180 },
      { field: 'dateCreated', headerName: this.$t('queryJob.dateOfCreation'), width: 180 },
      { field: 'customerRefNo', headerName: 'PO. No.', width: 180 },
      { field: 'customJobType', headerName: this.$t('queryJob.customJobType'), width: 180 },
      { field: 'op', headerName: this.$t('queryJob.operation'), width: 180 },
      { field: 'sales', headerName: this.$t('queryJob.sales'), width: 180 },
      { field: 'cargoSource', headerName: this.$t('queryJob.solicitationType'), width: 180 },
      { field: 'provisioned', headerName: this.$t('queryJob.accrued'), width: 180 },
      { field: 'jobState', headerName: this.$t('queryJob.status'), width: 180 },
      { field: 'chargeWeight', headerName: this.$t('queryJob.actualChargedWeight'), width: 180 },
      { field: 'containerNos', headerName: this.$t('queryJob.containerNo'), width: 180 },
      { field: 'realProfit', headerName: this.$t('queryJob.profit'), width: 180 },
      { field: 'grossProfitRate', headerName: this.$t('queryJob.grossProfitRate'), width: 180 },
      { field: 'income', headerName: this.$t('queryJob.totalIncome'), width: 180 },
      { field: 'cost', headerName: this.$t('queryJob.totalCost'), width: 180 },
      { field: 'due', headerName: this.$t('queryJob.payablesWriteOfStatus'), width: 180 },
      { field: 'receivable', headerName: this.$t('queryJob.receivablesWriteOfStatus'), width: 180 },
      { field: 'provisionedDate', headerName: this.$t('queryJob.accrualDate'), width: 180 },
      { field: 'createdBy', headerName: this.$t('queryJob.creator'), width: 180 },
      { field: 'containerDesc', headerName: this.$t('queryJob.containerDescription'), width: 180 },
      { field: 'designationAgent', headerName: this.$t('queryJob.designationAgent'), width: 180 },
      { field: 'paymentTermMBL', headerName: this.$t('queryJob.masterBLFreightTerm'), width: 180 },
      { field: 'paymentTermHBL', headerName: this.$t('queryJob.HBLFreightClause'), width: 180 },
      { field: 'destPortReturnTime', headerName: this.$t('SeaExport.DateOfReturningTheContainer'), width: 180 },
      { field: 'destPortDeliveryTime', headerName: this.$t('SeaExport.ReturnTime'), width: 180 },
      { field: 'customsDate', headerName: this.$t('SeaExport.OperationDate'), width: 180 }
    ]

    return excelColumnDefs
  }

  // 列表上方的打印按钮
  printClickHandler() {
    const uids = []
    const list = getGridSelected(this._view.gridOptions)
    for (const job of list) {
      uids.push(job.uuid)
    }
    if (uids.length > 0) {
      // TemplateSelectorWin.getInstance().showThisWin(_job, "JOBLIST", {"JOB_UUID":uids}, financeView);
      this._view.templateSelectorDialog.category = 'JOBLIST'
      this._view.templateSelectorDialog.data = { 'JOB_UUID': uids }
      this._view.templateSelectorDialog.visible = true
    } else {
      this.$message.warning(this.$t('Message.PleaseSelectTheBusinessToPrint'))
    }
  }
}

// 港口
function portLabelFunc(data, value) {
  if (!value) return ''
  if (data && value && Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === 'SI' || data.lob === 'SE')) {
    return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'auto_7')
  } else if (data && value && Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === 'AI' || data.lob === 'AE')) {
    return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', value, 'auto_8')
  }
  return ''
}
// 承运人c
function carrierLabelFunc(data, value) {
  if (!value) return ''
  if (data && value && Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === 'SI' || data.lob === 'SE')) {
    return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', value, 'auto_5')
  } else if (data && value && Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === 'AI' || data.lob === 'AE')) {
    return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', value, 'auto_6')
  }
  return ''
}

/**
 * 只显示空运业务的目的港
 */
function airDestinationPortFunction(data, value) {
  if (!value) value = data['destinationPortCode']
  if (data && value && Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === 'AI' || data.lob === 'AE')) {
    return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', value, 'auto_8')
  }
  return ''
}

/**
 * 交货地：海运出口显示destinationPortCode，其他显示destinationPlace
 */
function destinationPlaceFunction(data, value) {
  if (data && Object.prototype.hasOwnProperty.call(data, 'lob') && data.lob === 'SE') {
    return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', value, 'auto_7')
  }
  if (data && Object.prototype.hasOwnProperty.call(data, 'lob') && (data.lob === 'AI' || data.lob === 'SI')) {
    return data['destinationPlace']
  }
  return ''
}
